
  <!--  Loader Ends -->
  <!-- Main Body Starts -->
  <div class="container-fluid login-two-container">
    <div class="row main-login-two">
        <div class="col-xl-6 col-lg-6 col-md-6 d-none d-md-block p-0">
            <div class="login-bg">
                <div class="left-content-area">
                    <div class="card-content">
                        <h1 style="color: #fff">{{ 'login.oops!' | translate }}</h1>
                        <h4 style="color: #fff">{{ 'login.404' | translate }}</h4>
                        <a routerLink="/home" class="btn mt-4 btn-login-info" type="button">{{ 'login.backToHome' | translate }}</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-xl-6 col-lg-6 col-md-6 p-0">
          <div class="login-two-start">
            <img src="assets/img/error-503-1.jpg" width="460px"/>
          </div>
        </div>
    </div>
</div>
